import { ReactComponent as IconPressureError } from "../../../assets/img/icon_pressure_error.svg"
import { ReactComponent as IconPressureWarning } from "../../../assets/img/icon_pressure_warning.svg"
import { WarningType } from "./WarningType"


export const PressureIcon: React.FC<{ type:WarningType }> = ({type}) => {
    switch(type){
        case WarningType.Warning:
            return <IconPressureWarning width={26} height={26}  />
        default:
            return <IconPressureError width={26} height={26} />
    }
}